import { Injectable } from '@angular/core';
import { LanguageEntryValue } from '@osos/shared/api';
import { LanguagePresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';
@Injectable({
  providedIn: 'root',
})
export class LanguageParserV1Service extends ParserBase<
  LanguageEntryValue,
  LanguagePresenterModel
> {
  constructor() {
    super(LanguageEntryValue, LanguagePresenterModel, 1);
  }
  override getPresenterModel(
    model: Partial<LanguageEntryValue>,
  ): LanguagePresenterModel {
    return {
      id: model.id,
      code: model.code,
      direction: model.direction['id'],
      flag: model.flag,
      isDefault: model.isDefault,
      mobile_translation_file: model.mobile_translation_file,
      name: model.name,
      web_translation_files: model.web_translation_files,
    } as LanguagePresenterModel;
  }
  override getDataModel(presenter: LanguagePresenterModel): LanguageEntryValue {
    return {
      id: presenter.id,
      code: presenter.code,
      direction: presenter.direction,
      flag: presenter.flag,
      isDefault: presenter.isDefault,
      mobile_translation_file: presenter.mobile_translation_file,
      name: presenter.name,
      web_translation_files: presenter.web_translation_files,
    } as LanguageEntryValue;
  }
}
